import { useTranslation } from 'react-i18next';
import { useSnackbar, useSnackbarDispatchContext } from '@c2fo/liquidity';
import useDataDog from '@/reporting/DataDog';

interface ParticipationActionOptions {
  messageId: string;
  errorTitle: string;
  errorLocation: string;
  errorContext: Record<string, unknown>;
}

const useParticipationAction = () => {
  const { t } = useTranslation();
  const { addError } = useDataDog();
  const showSnackbar = useSnackbar();
  const dispatch = useSnackbarDispatchContext();

  const executeParticipationAction = async <T>(
    asyncOperation: () => Promise<T>,
    options: ParticipationActionOptions
  ): Promise<T | undefined> => {
    const { messageId, errorTitle, errorLocation, errorContext } = options;

    dispatch?.({
      type: 'enqueue',
      message: {
        id: messageId,
        closeable: false,
        content: t('buyerControls.turningParticipationOff'),
        loading: true,
        open: true,
      },
    });

    try {
      const result = await asyncOperation();
      dispatch?.({ type: 'dequeue', id: messageId });
      showSnackbar({
        message: t('buyerControls.participationTurnedOff'),
      });
      return result;
    } catch (error) {
      dispatch?.({ type: 'dequeue', id: messageId });
      showSnackbar({
        message: t('buyerControls.participationUpdateError'),
      });
      addError(errorTitle, {
        error,
        location: errorLocation,
        ...errorContext,
      });
      return undefined;
    }
  };

  return { executeParticipationAction };
};

export default useParticipationAction;
